'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var ClaimDetailsDescription = require('../components/ClaimDetailsDescription.js');
var nthBitHeader = require('@narvar/nth-bit-header');
var Box = require('../../../../../common/components/layout/Box/Box.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const Evaluations = _ref => {
  let {
    claim
  } = _ref;
  const {
    claimsClaimDetailsCustomerTitle,
    claimsClaimDetailsCustomerLabelEmail,
    claimsClaimDetailsCustomerLabelPhone,
    claimsClaimDetailsCustomerLabelBillingAddress,
    claimsClaimDetailsCustomerLabelShippingAddress
  } = nthHookTranslations.useTranslations();
  const {
    email,
    phone,
    billingAddress,
    shippingAddress
  } = claim.customer ?? {};
  return /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 2
  }, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.SmallHeader, {
    as: "h2"
  }, claimsClaimDetailsCustomerTitle), /*#__PURE__*/React__default["default"].createElement(ClaimDetailsDescription.ClaimDetailsDescriptionList, null, /*#__PURE__*/React__default["default"].createElement(ClaimDetailsDescription.ClaimDetailsDescriptionContainer, null, /*#__PURE__*/React__default["default"].createElement(ClaimDetailsDescription.ClaimDetailsDescriptionRow, null, email && /*#__PURE__*/React__default["default"].createElement(ClaimDetailsDescription.ClaimDetailsDescription, {
    label: claimsClaimDetailsCustomerLabelEmail,
    value: email
  }), phone && /*#__PURE__*/React__default["default"].createElement(ClaimDetailsDescription.ClaimDetailsDescription, {
    label: claimsClaimDetailsCustomerLabelPhone,
    value: phone
  })), /*#__PURE__*/React__default["default"].createElement(ClaimDetailsDescription.ClaimDetailsDescriptionRow, null, billingAddress && /*#__PURE__*/React__default["default"].createElement(ClaimDetailsDescription.ClaimDetailsDescription, {
    label: claimsClaimDetailsCustomerLabelBillingAddress,
    value: /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement("div", null, billingAddress.street1), (billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.street2) && /*#__PURE__*/React__default["default"].createElement("div", null, billingAddress.street2), /*#__PURE__*/React__default["default"].createElement("div", null, `${billingAddress.city ?? ''}, ${billingAddress.state ?? ''} ${billingAddress.zip ?? ''}`))
  }), shippingAddress && /*#__PURE__*/React__default["default"].createElement(ClaimDetailsDescription.ClaimDetailsDescription, {
    label: claimsClaimDetailsCustomerLabelShippingAddress,
    value: /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement("div", null, shippingAddress.street1), (shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.street2) && /*#__PURE__*/React__default["default"].createElement("div", null, shippingAddress.street2), /*#__PURE__*/React__default["default"].createElement("div", null, `${shippingAddress.city ?? ''}, ${shippingAddress.state ?? ''} ${shippingAddress.zip ?? ''}`))
  })))));
};
var Customer = nthHookTranslations.withTranslationsProvider(Evaluations, {
  translationKeys: ['claimsClaimDetailsCustomerTitle', 'claimsClaimDetailsCustomerLabelEmail', 'claimsClaimDetailsCustomerLabelPhone', 'claimsClaimDetailsCustomerLabelBillingAddress', 'claimsClaimDetailsCustomerLabelShippingAddress']
});

exports["default"] = Customer;
